// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3O9lT","title":"Info_title__2hU1R","links":"Info_links__3dco8","link":"Info_link__2Rv7Q","logo":"Info_logo__22cn5"};